import React from "react";
import DOMPurify from "dompurify";
import { ContentText } from "../MiscComponents";

const DiagnosisTabContent = ({ visitDetails }) => {
  return (
    <div className="mx-12">
      <div>
        <p className="font-bold text-2xl">DIAGNOSIS</p>
        <div className="mt-6 p-6 w-full bg-white rounded-xl">
          <div className="text-2xl font-medium opacity-50">
            {visitDetails?.diagnosis?.diagnosis}
          </div>
          <div
            className="text-3xl font-medium pt-5"
            dangerouslySetInnerHTML={{
              __html: visitDetails?.diagnosis?.diagnosis_detail_html,
            }}
          />
        </div>
      </div>
      <div className="pt-6">
        <p className="font-bold text-2xl">OTHER INSTRUCTIONS</p>
        <div className="mt-6 p-6 w-full bg-white rounded-xl">
          <div
            className="text-3xl font-medium"
            dangerouslySetInnerHTML={{
              __html: visitDetails?.diagnosis?.otherInstructionsHtml,
            }}
          />
        </div>
      </div>
      <div className="pt-6">
        <p className="font-bold text-2xl">FOLLOW UP</p>
        <div className="mt-6 p-6 w-full bg-white rounded-xl">
          <ContentText
            label={""}
            child={
              <p
              className="text-3xl font-medium text-black rounded-xl"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(visitDetails?.diagnosis?.followUpInstruction),
                }}
              />
            }
          />
          {visitDetails?.diagnosis?.follow_up_disclaimer && (
              <p className="mt-4 text-2xl text-grey-700">
                <span className="font-medium">Disclaimer:</span> <i>{visitDetails?.diagnosis?.follow_up_disclaimer}</i>
              </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiagnosisTabContent;
